import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  saveUserGoDashboardSettings,
  showGoDashboardSettings
} from "../../../../shared/services/Api/CommonService";
import AnimatedLoader from "../../../ui/animatedLoader";

const ModalSetting = ({ show, onHide, user_id }) => {
  const [membersOnly, setMembersOnly] = useState(false);
  const [email, setEmail] = useState("");
  const [emailList, setEmailList] = useState([]);
  const [formError, setFormError] = useState("");
  const [loading, setLoading] = useState(false);
  const validateEmail = (email) => {
    if (!email) {
      return "Please enter your email address.";

    } else if (!email.includes("@")) {
      return "Missing '@' symbol in email address.";
    }
    const [localPart, domain] = email.split("@");

    if (!localPart) {
      return "Missing username before '@'.";
    }

    if (!domain) {
      return "Missing domain after '@'.";
    }

    if (!domain.includes(".")) {
      return "Domain must contain a dot (e.g., gmail.com).";
    }

    const domainParts = domain.split(".");
    if (domainParts.some(part => part.trim() === "")) {
      return "Invalid domain structure.";
    }

    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!regex.test(email)) {
      return "Invalid email format.";
    }
    return "";
  };

  const parseEmails = (value) => {
    return value
      .split(",")
      .map((item) => item.trim())
      .filter((item) => item !== "");
  };

  const validateEmailsInput = (value) => {
    const emails = parseEmails(value);

    for (let i = 0; i < emails.length; i += 1) {
      const singleEmail = emails[i];
      const error = validateEmail(singleEmail);
      if (error) {
        return `${error} (\"${singleEmail}\")`;
      }
    }

    return "";
  };

  const valideEmail = email && validateEmailsInput(email);

  useEffect(() => {
    if (user_id && show) {
      (async () => {
        setLoading(true);
        try {
          const settings = await showGoDashboardSettings({ user_id });
          if (settings) {
            setMembersOnly(!!settings.members_only);
            setEmailList(settings.authorized_emails || []);
          }
        } catch (error) {
          console.error("Failed to fetch settings", error);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [user_id, show]);




  const handleEmailInput = (e) => {
    const email = e.target.value;
    setEmail(email)
  };

  const handleRemoveEmail = (removeEmail) => {
    setEmailList(emailList.filter((email) => email !== removeEmail));
  };

  const handleSave = async () => {
    try {
      setFormError("");
      setLoading(true);
      const newEmails = parseEmails(email);
      const response = await saveUserGoDashboardSettings({
        user_id,
        members_only: membersOnly,
        authorized_emails: newEmails.length ? [...emailList, ...newEmails] : emailList
      });
      if (response?.dashboard_setting?.authorized_emails) {
        setEmail('');
        setEmailList(response?.dashboard_setting?.authorized_emails);
      }
    } catch (error) {
      setFormError(error?.response?.data?.message || "Failed to save settings.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AnimatedLoader isLoading={loading} />
      <Modal show={show} size="lg" centered>
        <Modal.Body>
          <div className="modal__wrapper">
            <div className="inner__modal">
              <div className="team__modal edit-profile__modal">
                <button onClick={onHide} type="button">
                  <img src="/img/closemodal.svg" alt="close modal" />
                </button>

                <div className="modal__info">
                  {formError && <div className="form__error">{formError}</div>}
                  <div className="modal__info--main">
                    <h2>Settings</h2>
                  </div>

                  <div className="modal-setting">
                    <label className="modal-setting__checkbox">
                      <input
                        type="checkbox"
                        checked={membersOnly}
                        onChange={(e) => setMembersOnly(e.target.checked)}
                        disabled={loading}
                      />
                      Members Only
                    </label>

                    <div className="modal-setting__input-section">
                      <label className="modal-setting__emails-label">Authorized Emails</label>
                      <div className="modal-setting__email-list-section">
                        {emailList.map((email) => (
                          <span className="modal-setting__email-chip" key={email}>
                            {email}
                            <button
                              type="button"
                              className="modal-setting__email-remove"
                              onClick={() => handleRemoveEmail(email)}
                              disabled={loading}
                            >
                              &times;
                            </button>
                          </span>
                        ))}
                      </div>
                      <input
                        className="modal-setting__emails-input"
                        type="text"
                        value={email}
                        onChange={handleEmailInput}
                        placeholder={"Please enter your email"}
                        disabled={loading}
                      />
                      {valideEmail && (
                        <div className="form__error" style={{ marginBottom: "6px" }}>
                          {valideEmail}
                        </div>
                      )}
                    </div>

                    <button
                      className="modal-setting__save-btn"
                      type="button"
                      onClick={handleSave}
                      disabled={loading || valideEmail !== ""}
                      style={{
                        cursor: (loading || valideEmail.trim() !== "") ? "not-allowed" : "pointer",
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalSetting;